module.exports = __webpack_public_path__ + "img/photo-default.3ed9516b.svg";